(function () {
    'use strict';

    function initRangeSliders(context) {
        const sliders = (context || document).querySelectorAll('[data-component="range-slider"]');

        sliders.forEach(slider => {
            const input = slider.querySelector('input[type="range"]');
            const valueDisplay = slider.querySelector('.slider-value span');
            const valueBox = slider.querySelector('.slider-value');
            const track = slider.querySelector('.slider-track');

            function updateValue() {
                const { min, max } = getSliderValues();
                const value = parseFloat(input.value) || 0;
                const percentage = ((value - min) / (max - min)) * 100;
                
                // Update value display
                if (valueDisplay) {
                    valueDisplay.textContent = value;
                }
                
                // Update visual position and fill
                if (valueBox && track) {
                    valueBox.style.left = `${percentage}%`;
                    track.style.setProperty('--fill-width', `${percentage}%`);
                }
            }

            function updateValueFromPosition(clientX) {
                const rect = track.getBoundingClientRect();
                const { min, max, step } = getSliderValues();
                
                // Calculate position ratio (0-1) from mouse position
                const positionRatio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
                
                // Convert position to value and apply step constraints
                const rawValue = min + positionRatio * (max - min);
                const steppedValue = Math.round(rawValue / step) * step;
                const clampedValue = Math.max(min, Math.min(max, steppedValue));
                
                // Update input and trigger events
                input.value = clampedValue;
                updateValue();
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }

            function getSliderValues() {
                return {
                    min: parseFloat(input.min) || 0,
                    max: parseFloat(input.max) || 100,
                    step: parseFloat(input.step) || 1
                };
            }

            let isDragging = false;

            // Make value box draggable
            valueBox.addEventListener('mousedown', (e) => {
                isDragging = true;
                e.preventDefault();
            });

            // Click on track to set value
            track.addEventListener('click', (e) => {
                if (e.target === track || e.target === track.querySelector('::before')) {
                    updateValueFromPosition(e.clientX);
                }
            });

            document.addEventListener('mousemove', (e) => {
                if (isDragging) {
                    updateValueFromPosition(e.clientX);
                }
            });

            document.addEventListener('mouseup', () => {
                isDragging = false;
            });

            // Touch support
            valueBox.addEventListener('touchstart', (e) => {
                isDragging = true;
                e.preventDefault();
            });

            document.addEventListener('touchmove', (e) => {
                if (isDragging && e.touches.length > 0) {
                    updateValueFromPosition(e.touches[0].clientX);
                }
            });

            document.addEventListener('touchend', () => {
                isDragging = false;
            });

            input.addEventListener('input', updateValue);
            updateValue(); // Initial value
        });
    }

    // Initial load
    initRangeSliders();

    // Expose to global scope for re-initialization if needed
    window.initRangeSliders = initRangeSliders;
})();